import { defer, finalize, Observable } from 'rxjs';

export interface GridFetchGate {
  activeFetchCount(): number;
  whenIdle(): Promise<void>;
}

export const immediateFetchGate: GridFetchGate = {
  activeFetchCount: () => 0,
  whenIdle: () => Promise.resolve(),
};

export class GridFetchTracker implements GridFetchGate {
  private pendingFetches = 0;
  private idleWaiters: (() => void)[] = [];

  activeFetchCount(): number {
    return this.pendingFetches;
  }

  whenIdle(): Promise<void> {
    if (this.pendingFetches === 0) return Promise.resolve();
    return new Promise<void>((resolve) => this.idleWaiters.push(resolve));
  }

  notifyFetchStarted(): void {
    this.pendingFetches += 1;
  }

  notifyFetchCompleted(): void {
    this.pendingFetches = Math.max(0, this.pendingFetches - 1);
    if (this.pendingFetches > 0) return;
    const waiters = this.idleWaiters;
    this.idleWaiters = [];
    waiters.forEach((resolve) => resolve());
  }

  readonly track = <T>(source: Observable<T>): Observable<T> =>
    defer(() => {
      this.notifyFetchStarted();
      return source.pipe(finalize(() => this.notifyFetchCompleted()));
    });
}
